export const SITE_NAME = 'Recalls365';
export const SITE_URL = 'https://recalls365.com';
export const SITE_DESCRIPTION = 'Recalls365 is the iPhone recall alerts app for food, product, vehicle, pet, and medication safety updates with clear next steps.';
export const APP_STORE_ID = '6741032452';
export const APP_STORE_URL = `https://apps.apple.com/app/id${APP_STORE_ID}`;
export const DEFAULT_OG_IMAGE = `${SITE_URL}/icon.png`;
export const DEFAULT_ROBOTS = 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';
